module.exports = __webpack_public_path__ + "img/天合.png";